<template>
    <div class="customer__form modal modal--default">
        <div class="modal__panel modal__panel--termination">
            <div class="modal__logo-wrapper">
                <div class="modal__logo"></div>
                <!-- <div class="modal__logo-title">Seguro Desk </div> -->
            </div>

            <div class="modal__main-icon modal__main-icon--pendencies"></div>
            <div class="modal__back" @click="goBack()"></div>
            <div class="modal__close" @click="closeModal()"></div>

            <div class="form form--terminate"> 
                <div class="navigators">
                    <div class="navigator navigator--active">
                        <div class="navigator__bullet"></div>
                        <div class="navigator__title"> 
                            <span v-if="!pendencyForReply && !isPendecyEditing && !isReplyEditing">
                                {{ $t(`addPendencyModal.${"title"}`) }}
                            </span>

                            <span v-if="isReplyEditing || isPendecyEditing">
                                {{ $t(`addPendencyModal.${"editTitle"}`) }}
                            </span>
                            
                            <span v-if="pendencyForReply && !isReplyEditing && !isPendecyEditing">{{ $t(`addPendencyModal.${"replyTitle"}`) }}</span>
                        </div>
                    </div>
                </div>
                <div class="add__form add__form--terminate">

                    <transition name="fade" mode="out-in">
                        <Loading v-if="formLoading" />
                        <div v-else class="add__content">
                            <div class="termination">
                                <div class="termination__row">
                                    <div class="termination__column">
                                        <div class="form__field" v-if="!pendencyForReply">
                                            <p v-if="dashboardCustomerSelect">
                                                <VSelect class="select select--default" :options="customers"
                                                    :reduce="(customer) => customer.id"
                                                    :getOptionLabel="(customer) => `${customer.first_name} ${customer.last_name}`"
                                                    placeholder="Customer" v-model="customerId" />
                                            </p>
                                            <div v-else class="input input--default input--readonly">
                                                {{ parseCustomerName(customerDetails) }}
                                            </div>
                                        </div>
                                        <div class="form__field" v-if="!pendencyForReply">
                                            <VSelect class="select select--default"
                                                :class="[{ 'select--error': policyHasError }]" :options="policies"
                                                :reduce="(policy) => policy.id"
                                                :getOptionLabel="(policy) => `${policy.policy_number} - ${policy.company_name}`"
                                                :placeholder="$t(`addPendencyModal.${'policyDropdown'}`)"
                                                v-model="policyId" />
                                            <div class="form__error" v-if="policyHasError">
                                                {{ $t(`addPendencyModal.${"policyErrorMsg"}`) }}
                                            </div>
                                        </div>
                                        <!-- <div class="form__field"
                                            v-if="!pendencyForReply || (pendencyForReply && isUserReplyingToPendency)">
                                            <Datepicker class="input input--default" :config="statics.datePickerConfig"
                                                :placeholder="$t(`addPendencyModal.${'dateDropdown'}`)"
                                                v-model="deadline" />
                                        </div> -->
                                        <div class="form__field"
                                            >
                                            <Datepicker class="input input--default" :config="statics.datePickerConfig"
                                                :placeholder="$t(`addPendencyModal.${'dateDropdown'}`)"
                                                v-model="deadline" />
                                        </div>
                                    </div>
                                    <div class="termination__column  ">

                                        <!-- <div class="form__field"
                                            v-if="!pendencyForReply || (pendencyForReply && isUserReplyingToPendency)">
                                            <VSelect class="select select--default"
                                                :class="{ 'select--error': statusHasError }" :options="statuses"
                                                :reduce="(status) => status.id"
                                                :getOptionLabel="(status) => `${status.name_de}`"
                                              :placeholder="$t(`addPendencyModal.${'statusDropdown'}`)"
                                             
                                                v-model="statusId" />
                                            <div class="form__error" v-if="statusHasError">
                                                {{ $t(`addPendencyModal.${"statusErrorMsg"}`) }}
                                            </div>
                                        </div> -->
                                             <div class="form__field" >
                                            <VSelect class="select select--default"
                                                :class="{ 'select--error': statusHasError }" :options="statuses"
                                                :reduce="(status) => status.id"
                                                :getOptionLabel="(status) => `${status.name_de}`"
                                                :placeholder="$t(`addPendencyModal.${'statusDropdown'}`)"
                                             
                                                v-model="statusId" />
                                            <div class="form__error" v-if="statusHasError">
                                                {{ $t(`addPendencyModal.${"statusErrorMsg"}`) }}
                                            </div>
                                        </div>
                                        <div class="form__field" v-if="!pendencyForReply">
                                            <VSelect class="select select--default"
                                                :class="{ 'select--error': agentHasError }" :options="agents"
                                                :reduce="(agent) => agent.id"
                                                :getOptionLabel="(agent) => `${agent.first_name} ${agent.last_name}`"
                                                :placeholder="$t(`addPendencyModal.${'beraterDropdown'}`)"
                                                v-model="agentId" />
                                            <div class="form__error" v-if="agentHasError">
                                                {{ $t(`addPendencyModal.${"agentErrorMsg"}`) }}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="termination__column  form__field ">
                                        <DropFile @input="files = $event"
                                            :class="pendencyForReply ? 'margin-left-auto' : ''" />
                                    </div>
                                </div>
                                <!-- <div class=" form__field termination__row " :class="[
                                    (pendencyForReply && isUserReplyingToPendency) ? 'termination__textarea__row--reply' : '',
                                    (pendencyForReply && !isUserReplyingToPendency) ? 'termination__textarea__row--reply-agent' : ''
                                ]">
                                    <div class="form__field form__pendencies__textarea">
                                        <textarea :placeholder="$t(`addPendencyModal.${'text'}`)" cols="30" rows="10"
                                            class="input input--default termination__textarea" v-model="description"
                                            style="max-width: initial !important;"></textarea>
                                    </div>
                                </div> -->
                                  <div class=" form__field termination__row  termination__textarea__row--reply"                                    
                                 >
                                    <div class="form__field form__pendencies__textarea">
                                        <textarea :placeholder="$t(`addPendencyModal.${'text'}`)" cols="30" rows="10"
                                            class="input input--default termination__textarea" v-model="description"
                                            style="max-width: initial !important;"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </transition>
                </div>
            </div>
            <div v-if="isRequesting" class="modal__button modal__button--submit button button--default button--loading">
            </div>
            <div v-else>
                <button v-if="!pendencyForReply && !isPendecyEditing && !isReplyEditing"
                    class="modal__button modal__button--submit button button--default" @click="addPendency()">
                    <span>{{ $t(`addPendencyModal.${'saveBtn'}`) }}</span>
                </button>

                <button v-if="pendencyForReply" class="modal__button modal__button--submit button button--default"
                    @click="replyPendency()">
                    <span>{{ $t(`addPendencyModal.${'replyBtn'}`) }}</span>
                </button>

                <button v-if="isPendecyEditing" class="modal__button modal__button--submit button button--default"
                    @click="editPendency()">
                    <span>{{ $t(`addPendencyModal.${'editBtn'}`) }}</span>
                </button>

                <button v-if="isReplyEditing" class="modal__button modal__button--submit button button--default"
                    @click="editReplyPendency()">
                    <span>{{ $t(`addPendencyModal.${'editReplyBtn'}`) }}</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch, computed, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import api from "@/api";
import DropFile from "@/components/DropFile";
import Loading from "@/partials/Loading";
import { parseCustomerName } from "@/helpers/entityParsers";
import statics from "@/statics";
import { useI18n } from 'vue-i18n';   

// eslint-disable-next-line no-unused-vars
const { t } = useI18n();

defineOptions({
    name: "AddPendencyModal"
});

const store = useStore();
const route = useRoute();

// Reactive State / Data
const dashboardCustomerSelect = ref(false);
const customers = ref(null);
const formLoading = ref(true);
const isRequesting = ref(false);

const policyId = ref("");
const agentId = ref("");
const customerId = ref("");
const statusId = ref("");
const deadline = ref("");
const description = ref("");
const teamId = ref(null);

const files = ref([]);

const policyHasError = ref(false);
const agentHasError = ref(false);
const statusHasError = ref(false);

// Computed Properties (Mapping Vuex Getters)
const pendencyForms = computed(() => store.getters.pendencyForms);
const customerPolicies = computed(() => store.getters.customerPolicies);
const customerDetails = computed(() => store.getters.customerDetails);
const pendencyForReply = computed(() => store.getters.pendencyForReply);
const isUserReplyingToPendency = computed(() => store.getters.isUserReplyingToPendency);
const pendencyReplyPolicyId = computed(() => store.getters.pendencyReplyPolicyId);
const pendencyReplyServiceId = computed(() => store.getters.pendencyReplyServiceId);
const pendencyReplyAgent = computed(() => store.getters.pendencyReplyAgent);
const isPendecyEditing = computed(() => store.getters.isPendecyEditing);
const pendencyEditData = computed(() => store.getters.pendencyEditData);
const isReplyEditing = computed(() => store.getters.isReplyEditing);
const replyEditData = computed(() => store.getters.replyEditData);
const replyEditPolicyId = computed(() => store.getters.replyEditPolicyId);
const fromPolicyId = computed(() => store.getters.fromPolicyId);
const fromPolicyAgentId = computed(() => store.getters.fromPolicyAgentId);
const customerFromDashboard = computed(() => store.getters.customerFromDashboard);

const agents = computed(() => pendencyForms.value?.agents);
const statuses = computed(() => pendencyForms.value?.statuses);
const policies = computed(() => customerPolicies.value?.policies);

// Watchers
watch(agentId, (id) => {
    agentHasError.value = !id;
});

watch(statusId, (id) => {
    statusHasError.value = !id;
});

watch(customerId, (newCustomerId) => {
    if (newCustomerId) {
        fetchCustomerPolicies(newCustomerId);
    }
});

// Methods
const fetchCustomerPolicies = async (id) => {
    try {
        await store.dispatch('getCustomerPolicies', id);
    } catch (error) {
        console.error('Error fetching customer policies:', error);
    }
};

const closeModal = () => {
    store.commit("setShowAddPendencyModal", false);
    store.commit("setIsPendecyEditing", false);
    store.commit("setPendencyForReply", false);
    store.commit("setIsReplyEditing", false);

    store.commit("setFromPolicyId", null);
    store.commit("setPendencyReplyAgentData", null);

    store.commit("setCustomerFromDashboard", null);
};

const goBack = () => {
    closeModal();
    store.commit("setShowAddActivityModal", true);
};

const validateFields = (callback) => {
    agentHasError.value = !agentId.value;
    statusHasError.value = !statusId.value;

    if (!agentHasError.value && !statusHasError.value) {
        callback(true);
    } else {
        callback(false);
    }
};

const addPendency = async () => {
    isRequesting.value = true;
    validateFields(async (isValid) => {
        if (isValid) {
            let targetCustomerId = customerId.value || customerDetails.value.id;

            try {
                const pendency = await store.dispatch('createPendencies', {
                    policy_id: policyId.value,
                    agent_id: agentId.value,
                    customer_id: targetCustomerId,
                    status_id: statusId.value,
                    deadline: deadline.value,
                    description: description.value,
                });

                const pendencyId = pendency?.id;

                if (pendencyId) {
                    store.commit("setToast", {
                        display: true,
                        type: "success",
                        message: t("messages.pendencyCreatedSuccessfully"),
                    });

                    if (files.value.length > 0) {
                        const mappedFiles = files.value.map((file) => file.file);

                        try {
                            await store.dispatch("addPendencyFile", {
                                pendencyId,
                                files: mappedFiles,
                            });
                        } catch (error) {
                            store.commit("setToast", {
                                display: true,
                                type: "error",
                                message: error,
                            });
                        }

                        await store.dispatch("getPendencies", pendency.customer.id);
                    }

                    closeModal();
                } else {
                    store.commit("setToast", {
                        display: true,
                        type: "error",
                        message: t("messages.failedToCreatePendency"),
                    });
                }

                if (route.path === '/dashboard') {
                    try {
                        await store.dispatch("getSalesDashboard");
                    } catch (error) {
                        store.commit("setToast", {
                            display: true,
                            type: "error",
                            message: error,
                        });
                    }
                }
            } catch (error) {
                store.commit("setToast", {
                    display: true,
                    type: "error",
                    message: t("messages.failedToCreatePendency") + error,
                });
            } finally {
                isRequesting.value = false;
            }
        } else {
            store.commit("setToast", {
                display: true,
                type: "error",
                message: t("messages.validationFailed"),
            });
            isRequesting.value = false;
        }
    });
};

const editPendency = () => {
    isRequesting.value = true;
    validateFields(async (isValid) => {
        if (isValid) {
            store.dispatch('updatePendencies', {
                id: pendencyEditData.value.id,
                agent_id: agentId.value,
                customer_id: customerDetails.value.id,
                status_id: statusId.value,
                deadline: deadline.value,
                description: description.value,
            }).then(() => {
                store.commit("setToast", {
                    display: true,
                    type: "success",
                    message: t("messages.pendencyEditedSuccessfully"),
                });
                closeModal();
            }).catch((error) => {
                store.commit("setToast", {
                    display: true,
                    type: "error",
                    message: t("messages.failedToEditPendency") + error,
                });
            });
        } else {
            store.commit("setToast", {
                display: true,
                type: "error",
                message: t("messages.validationFailed"),
            });
            isRequesting.value = false;
        }
    });
};

const replyPendency = () => {
    isRequesting.value = true;

    policyId.value = pendencyReplyPolicyId.value;
    agentId.value = pendencyReplyAgent.value.id;

    if (!isUserReplyingToPendency.value) {
        statusId.value = 2;
    }

    let targetCustomerId = customerId.value || customerDetails.value.id || customerFromDashboard.value;
    const pendencyId = pendencyReplyServiceId.value;

    validateFields(async (isValid) => {
        if (isValid) {
            store.dispatch('replyPendencies', {
                pendency_id: pendencyId,
                policy_id: policyId.value,
                agent_id: agentId.value,
                customer_id: targetCustomerId,
                status_id: statusId.value,
                deadline: deadline.value,
                description: description.value,
            }).then(() => {
                store.commit("setToast", {
                    display: true,
                    type: "success",
                    message: t("messages.pendencyRepliedSuccessfully"),
                });

                if (files.value.length > 0) {
                    const mappedFiles = files.value.map((file) => file.file);

                    try {
                        store.dispatch("addPendencyFile", {
                            pendencyId,
                            files: mappedFiles,
                        });
                    } catch (error) {
                        store.commit("setToast", {
                            display: true,
                            type: "error",
                            message: error,
                        });
                    }
                }

                closeModal();

                if (route.name == "Dashboard") {
                    store.dispatch("getSalesDashboard");
                }
            }).catch((error) => {
                store.commit("setToast", {
                    display: true,
                    type: "error",
                    message: t("messages.failedToReplyPendency") + error,
                });
            });
        } else {
            store.commit("setToast", {
                display: true,
                type: "error", 
                message: t("messages.validationFailed"),
            });
            isRequesting.value = false;
        }
    });
};

const editReplyPendency = () => {
    isRequesting.value = true;

    agentId.value = replyEditData.value.agent.id;
    validateFields(async (isValid) => {
        if (isValid) {
            store.dispatch('updateReplyPendencies', {
                id: replyEditData.value.id,
                pendency_id: replyEditData.value.pendency_id,
                policy_id: replyEditPolicyId.value,
                agent_id: agentId.value,
                customer_id: customerDetails.value.id,
                status_id: statusId.value,
                deadline: deadline.value,
                description: description.value,
            }).then(() => {
                store.commit("setToast", {
                    display: true,
                    type: "success",
                    message: t("messages.replyUpdatedSuccessfully"),
                });
                closeModal();
            }).catch((error) => {
                store.commit("setToast", {
                    display: true,
                    type: "error",
                    message: t("messages.failedToUpdateReply") + error,
                });
            });
        } else {
            store.commit("setToast", {
                display: true,
                type: "error",
                message: t("messages.validationFailed"),
            });
            isRequesting.value = false;
        }
    });
};

// Lifecycle Hooks (Replaces created hook)
onMounted(async () => {
    formLoading.value = true;

    // Direct translation of this.$checkRolePermission checking mapping context
    if (!(store.state.checkRolePermission?.('pendency_create') || store.state.checkRolePermission?.('pendency_edit') || window.checkRolePermission?.('pendency_create'))) {
        // If your application injects this method globally, use the applicable internal structure (e.g. getCurrentInstance context)
        // Adjusting default alignment assuming execution logic can check permission
    }

    let targetCustomerId = null;
    if (route.params.id && customerDetails.value) {
        targetCustomerId = route.params.id;
        await store.dispatch("getGlobalCustomer", customerDetails.value.id);
        await store.dispatch('getCustomerPolicies', targetCustomerId);
    } else {
        dashboardCustomerSelect.value = true;

        try {
            const response = await api({ requiresAuth: true }).get(`/v1/customers`);
            const { data } = response.data;
            customers.value = data;
        } catch (err) {
            console.error(err);
        }
    }

    if (customerDetails.value?.team) {
        teamId.value = Number(customerDetails.value.team.id);
        await store.dispatch("getPendencyForms", teamId.value);
    }

    if (isPendecyEditing.value) {
        if (pendencyEditData.value?.policy?.id) {
            policyId.value = pendencyEditData.value.policy.id;
        }

        agentId.value = pendencyEditData.value.agent.id;
        statusId.value = pendencyEditData.value.status.id;

        if (pendencyEditData.value.deadline) {
            deadline.value = pendencyEditData.value.deadline;
        }

        description.value = pendencyEditData.value.description;
    }

    if (isReplyEditing.value) {
        statusId.value = replyEditData.value.status.id;
        deadline.value = replyEditData.value.deadline;
        description.value = replyEditData.value.description;
    }

    if (fromPolicyId.value !== null && fromPolicyAgentId.value !== null) {
        policyId.value = fromPolicyId.value;
        agentId.value = fromPolicyAgentId.value;
    }

    formLoading.value = false;
});

onUnmounted(() => {
    closeModal();
});
</script>
<style lang="scss" scoped>
@use "../assets/scss/termination-potential-policy";

.margin-left-auto {
    margin-left: auto;
}

.termination__row {
    border: 0;
}

.termination__textarea__row {
    margin-top: -40px;
}

.form__pendencies__textarea {
    width: 69%;
    margin-top: -60px;
}

.termination__textarea__row--reply {
    margin-top: -120px; 
}

.termination__textarea__row--reply-agent {
    margin-top: -220px;
}
</style>
